'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildButtonProps = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _dtmEvent = require('acq-components/lib/utils/DTM/dtmEvent');

var _Link = require('acq-components/lib/base-components/Link/Link');

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

var _componentHelpers = require('../../utils/component-helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildButtonProps = exports.buildButtonProps = function buildButtonProps(_ref) {
  var buttonData = _ref.buttonData,
      customClass = _ref.customClass,
      dtmAction = _ref.dtmAction,
      styles = _ref.styles,
      dtmHelper = _ref.dtmHelper,
      buttonKey = _ref.buttonKey,
      cardShortName = _ref.cardShortName,
      openModal = _ref.openModal;

  switch (buttonKey) {
    case 'compare':
      return {
        children: buttonData.title,
        className: (0, _lodash2.default)(styles, 'hero.link'),
        title: buttonData.hoverText,
        onClick: (0, _componentHelpers.getCompareButtonOnClickHandler)({
          dtmHelper: dtmHelper,
          cardShortName: cardShortName,
          compareLink: buttonData,
          section: _dtmConsts.DTM_CONSTS.top
        })
      };
    case 'modal':
      return {
        children: buttonData.title,
        className: (0, _classnames2.default)((0, _lodash2.default)(styles.hero, 'link'), 'hero-btn', customClass),
        title: buttonData.hoverText,
        onClick: function onClick() {
          (0, _dtmEvent.triggerDTMEvent)(dtmHelper.getDtmClickEventObj(dtmAction, _dtmConsts.DTM_CONSTS.hero));
          openModal();
        }
      };
    case 'speakToSpecialist':
    case 'applyNow':
    default:
      return {
        children: buttonData.title,
        className: (0, _classnames2.default)((0, _lodash2.default)(styles.hero, 'link'), 'hero-btn', customClass),
        Component: _Link.Link,
        href: dtmHelper.getUrlByLinkObj(buttonData, _dtmConsts.DTM_CONSTS.hero),
        onClick: function onClick() {
          return (0, _dtmEvent.triggerDTMEvent)(dtmHelper.getDtmClickEventObj(dtmAction, _dtmConsts.DTM_CONSTS.top));
        },
        title: buttonData.hoverText
      };
  }
};